import { NgModule } from '@angular/core'
import { I18nConfig, I18nModule, provideConfig } from '@spartacus/core'
import { mbChunks } from '../../../assets/translations/mb-chunks'
import { MbTranslatePipe } from './mbTranslate.pipe'
import { translations } from '../../../assets/translations/translations'

@NgModule({
  imports: [
    I18nModule
  ],
  declarations: [MbTranslatePipe],
  providers: [
    provideConfig({
      i18n: {
        resources: translations,
        chunks: mbChunks,
        fallbackLang: 'en'
      }
    } as I18nConfig)
  ],
  exports: [
    MbTranslatePipe,
    I18nModule
  ],
})
export class MbI18nModule {}
